<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.jobBase$ | async; as job) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <form class="col-lg-10">
                    <div class="form-group">
                      <label class="form-title-label" translate>JOB_LBL_NAME</label>
                      <div class="form-title">{{ job.name }}</div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (this.jobBase$ | async; as job) {
      <div class="col-comment">
        <app-comment-panel [entityType]="'Job'" [entityId]="job.id.toString()"></app-comment-panel>
      </div>
    }
  </div>
</div>
